import EnterCodeModal from './EnterCodeModal';
export default EnterCodeModal;
